/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Cashback History styles
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import styled from 'styled-components';

import { PageCashbackSideMenuWidth } from './CashbackStyled';

export const CashbackHistoryStyled = styled.div.attrs({
    className: 'cashback-history',
})`
    .page-title {
        min-height: 24px;
    }

    .cashback-history__title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;
    }

    .cashback-history__scores span {
        margin-left: 130px;
    }

    // Override table footer styles
    .table .table__table-footer {
        // side menu width + table padding
        left: calc(${PageCashbackSideMenuWidth}px + 32px);
    }

    .table-container_loading .table__table-footer {
        display: none;
    }

`;
